import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import CenterPanelUpdate from './centerPanel';
import RightPanelUpdate from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { updateWaitingAreaLogoPauseImage } from '../../../../actions/waitingArea.js';

export default function LogoPauseImage(props) {
  const dispatch = useDispatch();
  const imageLogoRef = useRef();
  const imagePauseRef = useRef();

  const saveLogoPauseImage = () => {
    const logoImg = imageLogoRef.current.getBase64();
    const pausedImg = imagePauseRef.current.getBase64();
    const isLogoDefaultSelected = imageLogoRef.current.getDefaultSelected() || false;
    const isPausedDefaultSelected = imagePauseRef.current.getDefaultSelected() || false;
    dispatch(
      updateWaitingAreaLogoPauseImage(
        props.waitingArea.id,
        logoImg,
        pausedImg,
        isLogoDefaultSelected,
        isPausedDefaultSelected
      )
    );
  };

  let rightPanel = {};
  let centerPanel = {};
  let title = undefined;
  let subtitle = undefined;
  let trimmedGroup = {};
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  var updatingWaitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';

  rightPanel = (
    <RightPanelUpdate
      waitingArea={props.waitingArea}
      saveLogoPauseImage={saveLogoPauseImage}
      waitingAreaLogoPauseImageForm={props.waitingAreaLogoPauseImageForm}
      readOnly={props.readOnly}
    />
  );
  centerPanel = (
    <CenterPanelUpdate
      imageLogoRef={imageLogoRef}
      imagePauseRef={imagePauseRef}
      waitingAreaLogoPauseImageForm={props.waitingAreaLogoPauseImageForm}
      waitingArea={props.waitingArea}
      readOnly={props.readOnly}
    />
  );
  title = APP.LANGUAGE.WaitingAreaLogoPauseImage.TitleUpdate;
  subtitle = updatingWaitingAreaName;
  let showModal = props.showWaitingAreaLogoPauseImageModal;

  return (
    <Modal show={showModal} hideWhenClickAway={false} className={'waiting-area-logo-pause-image'}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpLogoAndPauseImage}
        title={title}
        subtitle={subtitle}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
